import { map, pipe, propOr, reduce } from 'ramda';
import { MediaManagerSDKFile, MediaManagerSDKFileWithSectionInfo } from '../index';
import { ISectionData } from '../../../components/layouts/Sections/Section/Section.types';
import { MainSource } from '../../../constants/Source';
import { ItemType } from '../../../constants/ItemType';

const isAbsoluteUrl = (url: string) => url.indexOf('http') === 0 || url.indexOf('//') === 0;
const withoutLeadingSlash = (url: string) => (url.charAt(0) === '/' ? url.substring(1) : url);

export class RecommendedSource {
  settings: any;
  item: any;
  items: {
    list(): Promise<{ data: MediaManagerSDKFile[] }>;
  };

  constructor(settings) {
    if (!settings.customData) {
      console.warn('No customData provided! You will be redirected to Site Files');
    }

    const entities = pipe(
      propOr([], 'sections'),
      reduce<ISectionData, MediaManagerSDKFileWithSectionInfo[]>((items, section) => {
        const sectionItems = map<MediaManagerSDKFileWithSectionInfo, MediaManagerSDKFileWithSectionInfo>(
          (item) => ({
            ...item,
            id: `${item.id}/${section.title}`,
            sectionTitle: section.title,
            source: item.creator ? MainSource.MediaFromWix : MainSource.Recommended,
            kind: ItemType.File,
            fileUrl: isAbsoluteUrl(item.fileUrl) ? item.fileUrl : withoutLeadingSlash(item.fileUrl),
          }),
          (section.data || []) as MediaManagerSDKFileWithSectionInfo[],
        );
        return [...items, ...sectionItems];
      }, []),
    )(settings.customData);

    this.settings = settings;
    this.item = {};
    this.items = { list: () => Promise.resolve({ data: entities }) };
  }
}
